module.exports = __webpack_public_path__ + "static/media/ball4.389499a8.webp";